import { useEffect, useMemo, useRef, useState } from "react";
import { useReducedMotion } from "framer-motion";
import { Pause, Play } from "lucide-react";
import { t, useLanguage } from "@/i18n/LanguageContext";

export const HeroVideo = ({ src, poster }) => {
  useLanguage();
  const ref = useRef(null);
  const reducedMotion = useReducedMotion();
  const [playing, setPlaying] = useState(false);
  const [failed, setFailed] = useState(false);
  const [sourceIndex, setSourceIndex] = useState(0);
  const sources = useMemo(() => src.endsWith(".mp4") ? [src.replace(/\.mp4$/, ".webm"), src] : [src], [src]);
  useEffect(() => {
    setFailed(false);
    setSourceIndex(0);
  }, [src]);
  useEffect(() => {
    if (reducedMotion) ref.current?.pause();
    else ref.current?.play().catch(() => setPlaying(false));
  }, [src, sourceIndex, reducedMotion]);
  const nextSource = () => {
    if (sourceIndex + 1 < sources.length) setSourceIndex(sourceIndex + 1);
    else setFailed(true);
  };
  const toggle = () => {
    const video = ref.current;
    if (!video) return;
    if (video.paused) video.play().catch(() => setPlaying(false));
    else video.pause();
  };
  return <>
    {failed ? <img data-testid="hero-video-fallback" src={poster} alt="" className="h-full w-full object-cover opacity-90" /> :
      <video ref={ref} key={`${src}-${sourceIndex}`} src={sources[sourceIndex]} data-testid="hero-video" poster={poster} autoPlay={!reducedMotion} muted loop playsInline preload="metadata" aria-hidden="true" onPlay={() => setPlaying(true)} onPause={() => setPlaying(false)} onError={nextSource} className="h-full w-full object-cover opacity-90" />}
    {!failed && <button type="button" data-testid="hero-video-toggle" onClick={toggle} title={t(playing ? "Metti in pausa il video" : "Riprendi il video")} aria-label={t(playing ? "Metti in pausa il video" : "Riprendi il video")} className="absolute bottom-12 right-12 z-20 flex h-11 w-11 items-center justify-center rounded-full border border-white/40 bg-black/60 text-white transition-colors hover:bg-black/90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-white">
      {playing ? <Pause className="h-4 w-4" /> : <Play className="h-4 w-4" />}
    </button>}
  </>;
};